import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../../../../service/events/dashboard.service';
import { BaseView } from '../../../../view/base-view';
import { RequestHandler } from '../../../../service/OffService/request-handler';

import { CRMApiService } from '../../../../service/api/crm.service';
import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { CrmModel } from 'src/app/models/crm/crm.model';
import { CRMConsultasFormDefinition } from './form-definition';
import { environment } from 'src/environments/environment';
import { FormType } from '@fitogest/reactive-form-builder/interfaces';

@Component({
    selector: 'app-crm-consultas',
    standalone: false,
    templateUrl: './crm-consultas.component.html',
    styleUrls: ['./crm-consultas.component.scss']
})
export class CRMConsultasComponent extends BaseView<CrmModel> implements OnInit {

    public form!: CRMConsultasFormDefinition;
    public serverUrl = environment.serverUrl;
    public getRequest: RequestHandler<CrmModel[]> = this.cmrApi.CRM.GET;
    public deleteRequest: RequestHandler<CrmModel> = this.cmrApi.CRM.DELETE;
    public menuItemId = 'crm-consultas';

    public cols: ColInterface[] = [
        {field: 'fecha', header: 'Fecha'},
        {field: 'cliente_nombre', header: 'Cliente'},
        {field: 'tarea_comercial', header: 'Tarea Comercial'},
        {field: 'gerente', header: 'Gerente'},
        {field: 'responsable_calidad', header: 'Responsable de Calidad'},
        {field: 'estado_presupuesto', header: 'Estado Presupuesto'},
        {field: 'fecha_proxima_accion_comercial', header: 'Fecha Próxima Accion Comercial'},
        {field: 'productos', header: 'Productos'},
        {field: 'venta_cruzada', header: 'Venta Cruzada'},
        {field: 'realizado', header: 'Realizado'},
        {field: 'observaciones', header: 'Observaciones'}
    ];

    constructor(private dashboard: DashboardService, private cmrApi: CRMApiService) {
        super(dashboard, cmrApi.CRM.GET);
    }

    ngOnInit() {
        this.dashboard.setSubmenuItem('fincas', this.menuItemId);
    }

    public override show(modal: string, data: any): void {
        const formType = modal === 'delete' ? +FormType.DELETION : +FormType.INFORMATIVE;
        
        this.form = new CRMConsultasFormDefinition(formType, data as Record<string, string>, null);
    
        this.model = data;
        this.canShow[modal] = true;
    
        for (const key in this.canShow) {
          if (key !== modal && (this.canShow[key] ?? false)) { this.canShow[key] = false; }
        }
    }

    public globalConditionalStyle(_value: string, _cell: ColInterface) {
       return { textAlign: 'center' };
    }

    public globalVisualTransform(value: string, col: ColInterface) {
        if (col.field === 'realizado') {
            return (value === '1') ? 'Sí' : 'No';
        } else {
            return value;
        }
    }
}
